import { Col } from "antd"
import { useAppTranslation } from "app/hooks";
import { Streamer } from "models";
import { useNavigate } from "react-router-dom";

export interface StreamerCardProps {
  streamer: Streamer
}
const StreamerCard: React.FC<StreamerCardProps> = ({ streamer }) => {
  const navigate = useNavigate();
  const t = useAppTranslation();

  const handleItemClick = (streamerId: number, channel: string) => {
    navigate(`/streaming/streamer?streamerId=${streamerId}&chanel=${channel}`);
  };

  return <Col lg={{ span: 8 }}
    md={{ span: 12 }}
    sm={{ span: 16 }}
    xs={{ span: 24 }}
    className="casino-game-item"
  >
    <div className="platform-container">
      <div className="platform-body">
        <div className="platform-body__image-container">
          <img
            src={streamer.logo}
            alt={streamer.logo}
            className="platform-body__image"
            onError={(e) => {
              e.currentTarget.src = '/no_image.png';
            }}
          />
        </div>

        <div className="platform-infor">
          <p>{streamer.name}</p>
          <div className="platform-infor__viewmore">
            <button
              title="View more"
              className=""
              onClick={() => handleItemClick(streamer.id, streamer.platform.socialName)}
            >
              {t('stream.view')}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Col>
}

export default StreamerCard